module.exports = __webpack_public_path__ + "img/BoD_08_Mr_Kong_Eng_Huat.294ccb63.jpg";